import { useFormik } from 'formik';
import React from 'react'
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FORGOTPASS } from '../../../constant-value';
import { validationChangePass2Schema } from '../../../constant-value/schema';
import api from '../../../services/axiosConfig';

const ForgotChange = () => {
  const { mobile } = useParams();
  const navigate = useNavigate();
    const [body, setBody] = useState({
      phoneNumber: mobile,
      newPassword: null,
      confirmPassword: null,
      otpCode: null
    });
    
    //   const [otp, setOtp] = useState({
    //     phoneNumber: ''
    //   });
    
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
    } = useFormik({
        enableReinitialize: true,
        initialValues: body,
        validationSchema: validationChangePass2Schema,    
        onSubmit: () => {

          api.post(`/${FORGOTPASS}`, body).then((res) => {
                if (res.data.isSuccess) {
                    message(res.data.message,'success');
                    navigate("/login");
                } else {
                    message(res.data.message,'warn');
                }
            }).catch(error => { 
                message("جند دقیقه دیگر تلاش نمایید، خطایی رخ داده است", "warn");
            });
        },
    });

    const changeHandle = (evt) => {
        setBody({
          ...body,
          [evt.target.id]: evt.target.value,
        })
    }
    
      const message = (message,type) => {
        if (type==='warn') {
          toast.warning(message, {
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.success(message, {
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }

  return (
    // <form onSubmit={handleSubmit}>
    //   <div>
    //       <label>شماره همراه:</label>
    //       <input className="form-control"
    //         value={mobile}
    //         disabled
    //       />
    //   </div>
    //   <div>
    //     <label>رمز عبور:</label>
    //     <input className="form-control"
    //       value={values.newPassword}
    //       onChange={changeHandle}
    //       id="newPassword"
    //       type="password"
    //       onBlur={handleBlur}
    //     />
    //     {errors.newPassword && touched.newPassword && (
    //       <span>{errors.newPassword}</span>
    //     )}
    //   </div>
      
    //   <div>
    //     <label>تکرار رمز عبور:</label>
    //     <input className="form-control"
    //       value={values.confirmPassword}
    //       onChange={changeHandle}
    //       id="confirmPassword"
    //       type="password"
    //       onBlur={handleBlur}
    //     />
    //     {errors.confirmPassword && touched.confirmPassword && (
    //       <span>{errors.confirmPassword}</span>
    //     )}
    //   </div>
      
    //   <button className="btn btn-primary m-2" type="submit">ثبت نام</button>
    // </form>

    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <form onSubmit={handleSubmit} className="card shadow p-4">
            <h4 className="mb-4 text-center">تغییر رمز عبور</h4>

            {/* شماره همراه (غیرقابل ویرایش) */}
            <div className="mb-3">
              <label className="form-label">شماره همراه:</label>
              <input
                className="form-control"
                value={mobile}
                disabled
              />
            </div>

            {/* رمز عبور جدید */}
            <div className="mb-3">
              <label className="form-label">رمز عبور جدید:</label>
              <input
                className={`form-control ${
                  errors.newPassword && touched.newPassword ? "is-invalid" : ""
                }`}
                value={values.newPassword}
                onChange={changeHandle}
                id="newPassword"
                type="password"
                onBlur={handleBlur}
              />
              {errors.newPassword && touched.newPassword && (
                <div className="invalid-feedback">{errors.newPassword}</div>
              )}
            </div>

            {/* تکرار رمز عبور */}
            <div className="mb-4">
              <label className="form-label">تکرار رمز عبور:</label>
              <input
                className={`form-control ${
                  errors.confirmPassword && touched.confirmPassword
                    ? "is-invalid"
                    : ""
                }`}
                value={values.confirmPassword}
                onChange={changeHandle}
                id="confirmPassword"
                type="password"
                onBlur={handleBlur}
              />
              {errors.confirmPassword && touched.confirmPassword && (
                <div className="invalid-feedback">{errors.confirmPassword}</div>
              )}
            </div>

            {/* دکمه ثبت */}
            <button className="btn btn-primary w-100" type="submit">
              ثبت تغییرات
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotChange;